import { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth'
import { Spinner } from './components/Spinner'
import { BookPage } from './pages/BookPage'
import { CatalogPage } from './pages/CatalogPage'
import { ShelfPage } from './pages/ShelfPage'
import { StatusPage } from './pages/StatusPage'
import { UploadsPage } from './pages/UploadsPage'
import { LoginPage } from './pages/LoginPage'
import { ReaderPage } from './pages/ReaderPage'
import { applySettings, loadSettings } from './reader/settings'

function Shell() {
  const { username, loading } = useAuth()

  // Тема применяется ко всему приложению, а не только к читалке.
  useEffect(() => applySettings(loadSettings()), [])

  if (loading) return <Spinner />
  if (!username) return <LoginPage />

  return (
    <Routes>
      <Route path="/" element={<CatalogPage />} />
      <Route path="/book/:id" element={<BookPage />} />
      <Route path="/shelf" element={<ShelfPage />} />
      <Route path="/status" element={<StatusPage />} />
      <Route path="/uploads" element={<UploadsPage />} />
      <Route path="/read/:id" element={<ReaderPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  )
}
